import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material';

import { Template } from '../../../../_models/template';
import { Size } from '../../../../_models/size';
import { CardService } from '../../card.service';
import { ApplicationNotificationService } from '../../../../shared/application-notification.service';

@Component({
  moduleId: module.id,
  selector: 'copy-horizontal-component',
  templateUrl: 'copy-horizontal.component.html'
})

export class CopyHorizontalComponent implements OnInit {
  public horizontalCopyForm: FormGroup;

  ngOnInit() {
    // Generate form for horizontal copy
    const horizontalFormData: any = {};
    for (const template of this.template_and_size.size.cards) {
      if (template !== this.template_and_size.template) {
        horizontalFormData[template.name] = [false];
      }
    }
    this.horizontalCopyForm = this.formBuilder.group(horizontalFormData);
  }

  constructor(public cardService: CardService, private formBuilder: FormBuilder,
              public appNotificationService: ApplicationNotificationService, public dialog: MatDialog,
  @Inject(MAT_DIALOG_DATA) public template_and_size: {template: Template, size: Size}) {}

  copyHorizontal(): void {
    return this.horizontalCopyForm.value;
  }
}



// WEBPACK FOOTER //
// /app/src/app/hq/cards/copy-configuration/copy-to/copy-horizontal.component.ts